import type { PlanEvent } from "../../../../shared/types";
import { CATEGORY_BLOCK_COLORS } from "../../../../shared/types";

interface AllDayEventBlockProps {
  readonly event: PlanEvent;
  readonly index: number;
  readonly isPast: boolean;
  readonly onClick?: (event: PlanEvent, rect: DOMRect) => void;
}

export function AllDayEventBlock({
  event,
  index,
  isPast,
  onClick,
}: AllDayEventBlockProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        const colEl = e.currentTarget.closest("[data-daycol]");
        const colRect = colEl?.getBoundingClientRect();
        const btnRect = e.currentTarget.getBoundingClientRect();
        onClick?.(
          event,
          new DOMRect(
            colRect?.left ?? btnRect.left,
            btnRect.top,
            colRect?.width ?? btnRect.width,
            btnRect.height,
          ),
        );
      }}
      className={`absolute inset-x-0 rounded border-l-2 px-2 py-1.5 text-left select-none
        hover:brightness-110 focus:outline-none focus:ring-1 focus:ring-accent/50
        ${CATEGORY_BLOCK_COLORS[event.category]} ${isPast ? "opacity-10" : "opacity-25"}`}
      style={{
        top: 0,
        bottom: 0,
        zIndex: index,
      }}
    >
      <span className="block truncate font-semibold text-xs opacity-100">
        {event.title}
      </span>
      {event.recurrence && (
        <span className="text-[8px] opacity-60">↻</span>
      )}
    </button>
  );
}
